import gql from 'graphql-tag'

export const LIST_CUSTOM_ORDER_WEBHOOKS = gql`
  query ListCustomOrderWebhooks {
    listCustomOrderWebhooks {
      id
      name
      url
      headers {
        key
        value
      }
      enabled
    }
  }
`

export const CREATE_CUSTOM_ORDER_WEBHOOK = gql`
  mutation CreateCustomOrderWebhook(
    $name: String!
    $url: String!
    $headers: [WebhookHeaderInput!]
  ) {
    createCustomOrderWebhook(name: $name, url: $url, headers: $headers) {
      id
      name
      url
      headers {
        key
        value
      }
      enabled
    }
  }
`

export const UPDATE_CUSTOM_ORDER_WEBHOOK = gql`
  mutation UpdateCustomOrderWebhook(
    $id: uuid!
    $name: String
    $url: String
    $enabled: Boolean
    $headers: [WebhookHeaderInput!]
  ) {
    updateCustomOrderWebhook(
      id: $id
      name: $name
      url: $url
      enabled: $enabled
      headers: $headers
    ) {
      id
      name
      url
      headers {
        key
        value
      }
      enabled
    }
  }
`

export const DELETE_CUSTOM_ORDER_WEBHOOK = gql`
  mutation DeleteCustomOrderWebhook($id: uuid!) {
    deleteCustomOrderWebhook(id: $id)
  }
`
